import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { t } from 'ttag';

import { BannerPlacement, useAnimatedAppsBanner } from '@hook/useAnimatedAppsBanner';
import { ProfileProductsFeedContainer } from '@containers/ProfileProductsFeed';
import { AnimatedAppsPromotionBanner } from '@components/AnimatedAppsPromotionBanner';
import { useGotchaWebVitals } from '@hook/useGotchaWebVitals';

type RouteParams = {
  username: string
};

export const ProfilePage: React.FC = () => {
  const location = useLocation();
  const { username } = useParams<RouteParams>();

  useGotchaWebVitals({ pageName: 'profile' });

  const {
    placement,
    isCanShow,
    isVisible,
    handleShow,
    handleClose,
  } = useAnimatedAppsBanner(BannerPlacement.Profile);

  useEffect(() => {
    if (isCanShow) {
      handleShow();
    }
  }, [isCanShow, handleShow]);

  return (
    (
      <div>
        <Helmet>
          <title>{t`Профіль ${username}`}</title>
          <meta
            name="description"
            content={t`Магазин продавця ${username} на Shafa.ua ➤ Відгуки та опис товарів ➤ Замовляйте вигідно на Shafa.ua`}
          />

          {!!location.search && (
          <meta name="robots" content="noindex, nofollow" />
          )}
        </Helmet>
        <ProfileProductsFeedContainer username={username} />
        <AnimatedAppsPromotionBanner
          placement={placement}
          isVisible={isVisible}
          onClose={handleClose}
        />
      </div>
    )
  );
};

export default ProfilePage;
